'use client'

import React from 'react'
import storeConfig from 'reducers/store'
import { PersistGate } from 'redux-persist/integration/react'
import NavManager from 'containers/navManager'
import AlertManager from 'containers/alertManager'
import IsLoadingManager from 'containers/isLoadingManager'
import IsProfileLoaded from 'containers/isProfileLoaded'
import IsAppForeground from 'containers/isAppForeground'
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import ConnectionStatus from "components/connectionStatus"
import { Provider } from 'react-redux'
import IsUserLoggedIn from 'containers/IsUserLoggedIn'
import NotificationsManager from 'containers/notificationsManager'
import AppUrlListener from 'containers/appUrlListener'
import IsWeb from 'containers/isWeb'

if (typeof window !== "undefined") {
    defineCustomElements(window);
}

const { store, persistor } = storeConfig()

export default function StoreManager({ children }: { children: React.ReactNode }) {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <IsUserLoggedIn>
                    <AppUrlListener>
                        <NavManager>
                            <IsAppForeground>
                                <AlertManager />
                                <IsProfileLoaded>
                                    <IsLoadingManager />
                                    <ConnectionStatus>
                                        <NotificationsManager>
                                            <IsWeb>
                                                {children}
                                            </IsWeb>
                                        </NotificationsManager>
                                    </ConnectionStatus>
                                </IsProfileLoaded>
                            </IsAppForeground>
                        </NavManager>
                    </AppUrlListener>
                </IsUserLoggedIn>
            </PersistGate>
        </Provider>
    )
}
